// English texts of the "common" area: everyday words shared by every area.
// Use a common.* key only where the English text is exactly the same.
export default {
  "common.ok": "OK",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.save": "Save",
  "common.delete": "Delete",
  "common.remove": "Remove",
  "common.rename": "Rename",
  "common.edit": "Edit",
  "common.add": "Add",
  "common.create": "Create",
  "common.open": "Open",
  "common.back": "Back",
  "common.next": "Next",
  "common.done": "Done",
  "common.undo": "Undo",
  "common.redo": "Redo",
  "common.retry": "Retry",
  "common.continue": "Continue",
  "common.confirm": "Confirm",
  "common.yes": "Yes",
  "common.no": "No",
  "common.loading": "Loading…",
  "common.saving": "Saving…",
  "common.saved": "Saved",
  "common.error": "Error",
  "common.search": "Search",
  "common.settings": "Settings",
  "common.more": "More",
  "common.copy": "Copy",
  "common.cut": "Cut",
  "common.paste": "Paste",
  "common.duplicate": "Duplicate",
  "common.share": "Share",
  "common.export": "Export",
  "common.import": "Import",
  "common.download": "Download",
  "common.upload": "Upload",
  "common.today": "Today",
  "common.yesterday": "Yesterday",
  "common.tomorrow": "Tomorrow",
  "common.untitled": "Untitled",
  "common.name": "Name",
  "common.title": "Title",
  "common.notes": "Notes",
  "common.tags": "Tags",
  "common.map": "Map",
  "common.maps": "Maps",
  "common.folder": "Folder",
  "common.none": "None",
  "common.all": "All",
  "common.clear": "Clear",
  "common.apply": "Apply",
  "common.select": "Select",
  "common.show": "Show",
  "common.hide": "Hide",
  "common.later": "Later",
  "common.logout": "Log out",
};
